function redirectToModulesList() {
    window.location.href = `/ModulesList`;
}

function showError(message) {
    createToast("error",message);
}
document.addEventListener('DOMContentLoaded', function () {
    const toastContainer = document.getElementById('notifications');
    if (typeof sessionStorage.getItem("PendingError") === 'string' && toastContainer) {
        let pendingError = sessionStorage.getItem("PendingError");
        showError(pendingError);
        sessionStorage.removeItem("PendingError");
    }
})

function focusElement(id) { document.getElementById(id).focus(); }

function setBodyOverflow(value) {
    document.body.style.overflow = value;
}
function UNITY_SetBackgoundToDefaultColor() {
    document.body.style.backgroundColor = getComputedStyle(document.documentElement).getPropertyValue('--default-color').trim();
}
function BLAZOR_SendPauseAR(valueFromBlazor) {
    if (typeof Unity !== 'undefined') {
        Unity.call("SendPauseAR/" + valueFromBlazor);
    } else {
    }
}
function blazorComponentLoaded() {
    setOverflowBehaviours();
}

function checkAndLeaveAr() {
    /*SetBtnNextBackVisible(true)*/
    if (typeof Unity !== 'undefined') {
        Unity.call("LeaveAr");
    } else {
    }
    UNITY_SetBackgoundToDefaultColor();
};


function setOverflowBehaviours() {

    // Function to check overflow for a given container
    function checkOverflow(container) {
        if (container.scrollWidth > container.clientWidth) {
            container.classList.remove('plume-hided');
        } else {
            container.classList.add('plume-hided');
        }
    }

    // Function to find the closest ancestor with overflow properties
    function findOverflowContainer(element) {
        let current = element.parentElement;
        while (current) {
            var style = window.getComputedStyle(current);
            if (style.overflow === 'auto' || style.overflow === 'scroll' || style.overflowX === 'auto' || style.overflowX === 'scroll') {
                return current;
            }
            current = current.parentElement;
        }
        return null;
    }

    // Debounce function to limit the rate at which a function can fire
    function debounce(func, wait) {
        let timeout;
        return function (...args) {
            var context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    }

    // Initial check for all pw-primary-right-plume elements
    function updatePlumes() {
        document.querySelectorAll('.pw-primary-right-plume').forEach(plume => {
            var container = findOverflowContainer(plume);
            if (container) {
                checkOverflow(container);
            }
        });
    }

    // Check on window resize with debounce
    window.addEventListener('resize', debounce(updatePlumes, 200));

    // Initial check
    updatePlumes();
}

function handleTogglePasswords() {
    const toggleElements = document.querySelectorAll('.toggle-password');
    toggleElements.forEach(function (toggleElement) {
        toggleElement.addEventListener('click', function () {
            const targetId = this.getAttribute('aria-controls');
            const inputField = document.getElementById(targetId);
            const eyeShowIcon = this.querySelector('.eye-show');
            const eyeHideIcon = this.querySelector('.eye-hide');
            if (inputField.type === 'password') {
                inputField.type = 'text';
                eyeShowIcon.style.display = 'none';
                eyeHideIcon.style.display = 'block';
                this.setAttribute('aria-pressed', 'true');
                this.setAttribute('aria-label', this.dataset.labelHide);
            } else {
                inputField.type = 'password';
                eyeShowIcon.style.display = 'block';
                eyeHideIcon.style.display = 'none';
                this.setAttribute('aria-pressed', 'false');
                this.setAttribute('aria-label', this.dataset.labelShow);
            }
        });
    });
}
document.addEventListener("DOMContentLoaded", function () {
    setOverflowBehaviours();

    handleTogglePasswords();
    
});